// Timer.js
import React, { useState, useEffect, useRef } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import imgUrl from "../../../images/timer.webp";
const TITLE = "Timer Waktu - Timer Elektronik Akurat - Penghitung Waktu";
const DESCRIPTION = "Timer elektronik akurat untuk hitung mundur dan hitung maju. Alat timer waktu yang sempurna untuk memasak, olahraga, belajar, shalat, dan aktivitas apa pun yang membutuhkan waktu tepat. Timer mudah digunakan, bekerja online tanpa unduh.";
const KEYWORDS = "timer waktu, penghitung mundur, timer elektronik, timer masak, timer olahraga, timer belajar, penghitung maju";
const OG_URL = "https://do-calculate.com/calculator/id/timer/";
const Timer = () => {
    const [time, setTime] = useState(0);
    const [isActive, setIsActive] = useState(true);
    const [isCountdown, setIsCountdown] = useState(false);
    const [inputMinutes, setInputMinutes] = useState(0);
    const [inputSeconds, setInputSeconds] = useState(0);
    const [soundEnabled, setSoundEnabled] = useState(true);
    const audioContextRef = useRef(null);
    const hasPlayedSoundRef = useRef(false);
    const presetTimers = [
        [
            { label: "Timer 1 menit", value: 60 },
            { label: "Timer 3 menit", value: 180 }
        ],
        [
            { label: "Timer 5 menit", value: 300 },
            { label: "Timer 10 menit", value: 600 }
        ],
        [
            { label: "Timer 15 menit", value: 900 },
            { label: "Timer 20 menit", value: 1200 }
        ],
        [
            { label: "Timer 30 menit", value: 1800 },
            { label: "Timer 40 menit", value: 2400 }
        ],
        [
            { label: "Timer 45 menit", value: 2700 },
            { label: "Timer 60 menit", value: 3600 }
        ],
        [
            { label: "Timer 10 detik", value: 10 },
            { label: "Timer 20 detik", value: 20 }
        ],
        [
            { label: "Timer 30 detik", value: 30 },
            { label: "Timer 45 detik", value: 45 }
        ],
        [
            { label: "Timer 60 detik", value: 60 },
            { label: "Timer 90 detik", value: 90 }
        ],
        [
            { label: "Timer 1 jam", value: 3600 },
            { label: "Timer 2 jam", value: 7200 }
        ],
        [
            { label: "Timer 4 jam", value: 14400 },
            { label: "Timer 8 jam", value: 28800 }
        ]
    ];
    // Initialize audio context
    useEffect(() => {
        audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
        return () => {
            if (audioContextRef.current) {
                audioContextRef.current.close();
            }
        };
    }, []);
    // Play alarm sound using Web Audio API
    const playAlarmSound = () => {
        if (!soundEnabled || !audioContextRef.current) return;
        const context = audioContextRef.current;
        // Play a sequence of beeps
        const playBeep = (frequency, startTime, duration) => {
            const oscillator = context.createOscillator();
            const gainNode = context.createGain();
            oscillator.connect(gainNode);
            gainNode.connect(context.destination);
            oscillator.frequency.value = frequency;
            oscillator.type = 'sine';
            gainNode.gain.setValueAtTime(0, startTime);
            gainNode.gain.linearRampToValueAtTime(0.3, startTime + 0.01);
            gainNode.gain.linearRampToValueAtTime(0, startTime + duration);
            oscillator.start(startTime);
            oscillator.stop(startTime + duration);
        };
        const now = context.currentTime;
        // Play 3 beeps
        playBeep(800, now, 0.2);
        playBeep(800, now + 0.3, 0.2);
        playBeep(800, now + 0.6, 0.3);
    };
    useEffect(() => {
        setTime(0);
        setIsCountdown(false);
        setIsActive(true);
    }, []);
    useEffect(() => {
        let interval = null;
        if (isActive) {
            interval = setInterval(() => {
                setTime((prevTime) => {
                    if (isCountdown) {
                        if (prevTime <= 0) {
                            clearInterval(interval);
                            if (!hasPlayedSoundRef.current) {
                                playAlarmSound();
                                hasPlayedSoundRef.current = true;
                            }
                            return 0;
                        }
                        return prevTime - 1;
                    } else {
                        return prevTime + 1;
                    }
                });
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isActive, isCountdown]);
    const toggleTimer = () => {
        setIsActive(!isActive);
    };
    const resetTimer = () => {
        setTime(0);
        setIsActive(false);
        hasPlayedSoundRef.current = false;
    };
    const startCountdown = () => {
        const totalSeconds = (inputMinutes * 60) + parseInt(inputSeconds);
        setTime(totalSeconds);
        setIsCountdown(true);
        setIsActive(true);
        hasPlayedSoundRef.current = false;
    };
    const handlePresetTimer = (seconds) => {
        setTime(seconds);
        setIsCountdown(true);
        setIsActive(true);
        setInputMinutes(Math.floor(seconds / 60));
        setInputSeconds(seconds % 60);
        hasPlayedSoundRef.current = false;
    };
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };
    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
                IMAGE={imgUrl}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
                <div className="col-12 col-md-4 text-center">
                    <img
                        src={imgUrl}
                        alt="Timer Waktu"
                        width="300px"
                        height="300px"
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div
                        className="bg-success text-white text-center"
                        style={{ height: "50px" }}
                    >
                        <h1 style={{ fontSize: "17px" }}>
                            Timer Waktu Elektronik - Penghitung Mundur
                        </h1>
                    </div>
                    <p>
                        Gunakan timer elektronik gratis ini untuk mengatur waktu dengan tepat untuk aktivitas apa pun,
                        baik untuk memasak, olahraga, belajar, atau shalat. Anda dapat memilih antara timer
                        hitung maju (stopwatch) atau timer hitung mundur (countdown timer) dengan mudah dan antarmuka yang sederhana. Nikmati pengalaman timer
                        yang akurat dan efektif yang memenuhi semua kebutuhan waktu Anda.
                    </p>
                    <u>Cara menggunakan timer:</u>
                    <ul>
                        <li>Untuk menjalankan timer hitung maju, tekan tombol "Mulai".</li>
                        <li>Untuk menghentikan timer sementara, tekan tombol "Berhenti".</li>
                        <li>Untuk mereset timer ke nol, tekan tombol "Reset".</li>
                        <li>Untuk mengatur timer hitung mundur, masukkan menit dan detik yang diinginkan lalu tekan "Mulai Hitung Mundur".</li>
                        <li>Anda juga dapat menggunakan tombol preset untuk mengatur waktu tertentu dengan cepat.</li>
                    </ul>
                    <MobileUnderCalAds />
                    <div
                        className="border border-light shadow-lg p-4 rounded"
                        style={{
                            backgroundColor: "#f8f9fa",
                            borderRadius: "10px",
                            boxShadow: "0px 4px 15px rgba(0,0,0,0.1)",
                        }}
                    >
                        <div className="row">
                            <div className="col calculatorStyle">
                                <div className="p-3 mb-2 bg-success text-white text-center">
                                    <h2 style={{ fontSize: "24px" }}>Tampilan Waktu</h2>
                                </div>
                                <hr />
                                <div>
                                    <div className="text-center my-4">
                                        <div
                                            style={{
                                                background: "linear-gradient(135deg, #ffffff 0%, #e0f7fa 100%)",
                                                color: time <= 10 && isCountdown ? "#f44336" : "#4caf50",
                                                borderRadius: "50%",
                                                width: "200px",
                                                height: "200px",
                                                lineHeight: "200px",
                                                fontSize: "48px",
                                                fontWeight: "bold",
                                                margin: "0 auto",
                                                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                userSelect: "none",
                                            }}
                                        >
                                            {formatTime(time)}
                                        </div>
                                    </div>
                                    <div className="text-center mt-3 mb-3">
                                        <label style={{ fontSize: "14px", color: "#666" }}>
                                            <input
                                                type="checkbox"
                                                checked={soundEnabled}
                                                onChange={(e) => setSoundEnabled(e.target.checked)}
                                                style={{ marginLeft: "8px" }}
                                            />
                                            Aktifkan suara saat timer berakhir
                                        </label>
                                    </div>
                                    <div className="text-center mt-2">
                                        <button
                                            className="text-white px-4 py-2 mx-2"
                                            style={{
                                                background: isActive
                                                    ? "linear-gradient(135deg, #f44336 0%, #e57373 100%)"
                                                    : "linear-gradient(135deg, #4caf50 0%, #81c784 100%)",
                                                borderRadius: "20px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                border: "none",
                                                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                transition: "background 0.3s",
                                                padding: "15px",
                                            }}
                                            onClick={toggleTimer}
                                        >
                                            {isActive ? "Berhenti" : "Mulai"}
                                        </button>
                                        <button
                                            className="text-white px-4 py-2 mx-2"
                                            style={{
                                                background: "linear-gradient(135deg, #2196f3 0%, #64b5f6 100%)",
                                                borderRadius: "20px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                border: "none",
                                                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                transition: "background 0.3s",
                                                padding: "15px",
                                            }}
                                            onClick={resetTimer}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col calculatorStyle">
                                <div className="p-3 mb-2 bg-success text-white text-center">
                                    <h2 style={{ fontSize: "24px" }}>Atur Timer Hitung Mundur</h2>
                                </div>
                                <hr />
                                <div>
                                    <div className="text-center my-4">
                                        <div className="d-flex justify-content-center">
                                            <div className="mx-2">
                                                <label>Menit</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    max="59"
                                                    value={inputMinutes}
                                                    onChange={(e) => setInputMinutes(e.target.value)}
                                                    className="form-control text-center"
                                                    style={{ width: "90%" }}
                                                />
                                            </div>
                                            <div className="mx-2">
                                                <label>Detik</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    max="59"
                                                    value={inputSeconds}
                                                    onChange={(e) => setInputSeconds(e.target.value)}
                                                    className="form-control text-center"
                                                    style={{ width: "90%" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-center mt-2">
                                        <button
                                            className="text-white px-4 py-2"
                                            style={{
                                                background: "linear-gradient(135deg, #ff9800 0%, #ffb74d 100%)",
                                                borderRadius: "20px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                border: "none",
                                                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
                                                transition: "background 0.3s",
                                                padding: "15px",
                                            }}
                                            onClick={startCountdown}
                                        >
                                            Mulai Timer Hitung Mundur
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col calculatorStyle">
                                <div className="p-3 mb-2 bg-success text-white text-center">
                                    <h2 style={{ fontSize: "24px" }}>Timer Siap Pakai</h2>
                                </div>
                                <hr />
                                <div>
                                    <table className="bmi-table" style={{ width: "100%" }}>
                                        <tbody>
                                            {presetTimers.map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {row.map((preset, colIndex) => (
                                                        <td
                                                            key={colIndex}
                                                            style={{
                                                                cursor: "pointer",
                                                                padding: "12px 8px",
                                                                color: "#1a73e8",
                                                                fontWeight: "bold",
                                                                fontSize: "14px",
                                                                minWidth: "150px",
                                                                textAlign: "center",
                                                                border: "1px solid #e0e0e0",
                                                                transition: "all 0.3s ease",
                                                                backgroundColor: "#ffffff"
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.backgroundColor = "#f1f3f4";
                                                                e.currentTarget.style.color = "#0d47a1";
                                                                e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.backgroundColor = "#ffffff";
                                                                e.currentTarget.style.color = "#1a73e8";
                                                                e.currentTarget.style.boxShadow = "none";
                                                            }}
                                                            onClick={() => handlePresetTimer(preset.value)}
                                                        >
                                                            <span style={{
                                                                borderBottom: "2px dotted #1a73e8",
                                                                paddingBottom: "2px",
                                                                transition: "all 0.3s ease"
                                                            }}>
                                                                <h3 style={{ fontSize: '15px' }}>{preset.label}</h3>
                                                            </span>
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: "auto" }}>
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                Panduan Penggunaan Timer Elektronik
                            </div>
                            <div className="info-section-body">
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>Apa Itu Timer Elektronik?</u>
                                    </h2>
                                    <p>
                                        <b>Timer elektronik</b> atau <b>timer digital</b> adalah alat gratis yang berfungsi secara online tanpa perlu mengunduh aplikasi apa pun. <b>Timer waktu</b> ini menyediakan cara yang akurat dan mudah untuk melacak waktu dalam aktivitas apa pun yang Anda lakukan, baik Anda memerlukan <b>penghitung mundur</b> (countdown timer) atau <b>penghitung maju</b> (stopwatch).
                                    </p>
                                    <p>
                                        <b>Timer waktu</b> ini memiliki antarmuka yang sederhana dan mudah digunakan, dengan kemampuan mengatur waktu dalam menit dan detik, serta menyediakan kumpulan <b>timer siap pakai</b> untuk waktu yang sering digunakan. Juga dilengkapi dengan <b>peringatan suara</b> saat waktu yang ditentukan berakhir untuk memastikan Anda tidak melewatkan janji atau tugas apa pun.
                                    </p>
                                </div>
                                <hr />
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>Cara Menggunakan Timer:</u>
                                    </h2>
                                    <h3 style={{ fontSize: "16px" }}>
                                        <b>1. Timer Hitung Maju (Stopwatch):</b>
                                    </h3>
                                    <ul>
                                        <li>Tekan tombol "Mulai" untuk mulai menghitung waktu dari nol</li>
                                        <li>Anda dapat menjeda timer dengan menekan "Berhenti" lalu melanjutkannya dengan menekan "Mulai" lagi</li>
                                        <li>Tekan "Reset" untuk mengembalikan penghitung ke nol</li>
                                        <li>Ideal untuk mengukur durasi latihan olahraga, waktu belajar, atau aktivitas lainnya</li>
                                    </ul>
                                    <h3 style={{ fontSize: "16px" }}>
                                        <b>2. Timer Hitung Mundur (Countdown Timer):</b>
                                    </h3>
                                    <ul>
                                        <li>Masukkan jumlah menit dan detik yang diinginkan di kolom input</li>
                                        <li>Tekan tombol "Mulai Timer Hitung Mundur" untuk memulai hitung mundur</li>
                                        <li>Warna penghitung akan berubah menjadi merah saat tersisa 10 detik atau kurang</li>
                                        <li>Saat waktu mencapai nol, timer akan mengeluarkan bunyi peringatan (jika diaktifkan)</li>
                                        <li>Anda dapat menghentikan atau mereset timer kapan saja</li>
                                    </ul>
                                    <h3 style={{ fontSize: "16px" }}>
                                        <b>3. Menggunakan Timer Siap Pakai:</b>
                                    </h3>
                                    <ul>
                                        <li>Pilih dari timer siap pakai yang tersedia (dari 10 detik hingga 8 jam)</li>
                                        <li>Tekan waktu apa pun dari tabel untuk memulai timer hitung mundur langsung</li>
                                        <li>Waktu akan diatur secara otomatis dan hitung mundur akan dimulai langsung</li>
                                    </ul>
                                </div>
                                <hr />
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>Penggunaan Timer Elektronik:</u>
                                    </h2>
                                    <ul>
                                        <li><b>Timer Memasak:</b> Untuk mengatur waktu memasak makanan dengan tepat dan menghindari gosong atau kurang matang</li>
                                        <li><b>Timer Olahraga:</b> Untuk mengatur waktu latihan, sesi HIIT, atau waktu istirahat</li>
                                        <li><b>Timer Belajar:</b> Untuk menerapkan teknik Pomodoro (25 menit kerja + 5 menit istirahat)</li>
                                        <li><b>Timer Shalat:</b> Untuk mengingatkan waktu shalat atau menentukan waktu untuk dzikir dan membaca Al-Qur'an</li>
                                        <li><b>Timer Rapat:</b> Untuk mengatur waktu rapat dan presentasi</li>
                                        <li><b>Timer Permainan:</b> Untuk mengatur waktu permainan dan kompetisi keluarga</li>
                                        <li><b>Timer Perawatan Pribadi:</b> Untuk mengatur waktu masker wajah, pewarnaan rambut, atau perawatan</li>
                                        <li><b>Timer Kerja:</b> Untuk mengatur waktu kerja dan meningkatkan produktivitas</li>
                                        <li><b>Timer Anak-anak:</b> Untuk menentukan waktu bermain, belajar, atau tidur</li>
                                    </ul>
                                </div>
                                <hr />
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>Fitur Timer:</u>
                                    </h2>
                                    <ul>
                                        <li>Antarmuka sederhana dan mudah digunakan dengan tampilan waktu yang jelas</li>
                                        <li>Berfungsi online tanpa unduh atau instalasi</li>
                                        <li>100% gratis tanpa iklan yang mengganggu</li>
                                        <li>Peringatan suara saat timer hitung mundur berakhir (dapat diaktifkan atau dinonaktifkan)</li>
                                        <li>Perubahan warna penghitung menjadi merah pada 10 detik terakhir untuk peringatan visual</li>
                                        <li>Timer siap pakai untuk waktu yang sering digunakan</li>
                                        <li>Kemampuan jeda dan lanjutkan</li>
                                        <li>Reset cepat untuk memulai dari awal</li>
                                        <li>Kompatibel dengan semua perangkat (komputer, ponsel, tablet)</li>
                                        <li>Akurasi tinggi dalam pengaturan detik</li>
                                        <li>Desain menarik dengan efek visual profesional</li>
                                    </ul>
                                </div>
                                <hr />
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>Teknik Pomodoro:</u>
                                    </h2>
                                    <p>
                                        <b>Timer elektronik</b> adalah alat yang ideal untuk menerapkan teknik Pomodoro yang terkenal untuk meningkatkan produktivitas dan konsentrasi:
                                    </p>
                                    <ol>
                                        <li>Pilih tugas untuk dikerjakan</li>
                                        <li>Atur timer selama 25 menit (gunakan timer 20 menit + 5 menit)</li>
                                        <li>Kerjakan tugas dengan fokus penuh hingga waktu habis</li>
                                        <li>Ambil istirahat singkat selama 5 menit</li>
                                        <li>Setelah 4 sesi, ambil istirahat panjang (15-30 menit)</li>
                                    </ol>
                                    <p>
                                        Gunakan <b>timer siap pakai</b> di bawah untuk memilih 30 menit untuk bekerja atau 5 menit untuk istirahat dengan sekali tekan!
                                    </p>
                                </div>
                                <hr />
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>Tips Penggunaan Optimal:</u>
                                    </h2>
                                    <ol>
                                        <li>Pastikan suara diaktifkan di browser Anda untuk mendengar peringatan saat waktu habis</li>
                                        <li>Gunakan timer siap pakai untuk akses cepat ke waktu yang sering digunakan</li>
                                        <li>Perhatikan perubahan warna penghitung menjadi merah pada 10 detik terakhir sebagai peringatan visual</li>
                                        <li>Anda dapat menjeda timer sementara jika diperlukan tanpa kehilangan waktu</li>
                                        <li>Gunakan timer hitung maju untuk mengukur durasi sebenarnya dari tugas</li>
                                        <li>Atur beberapa timer di perangkat berbeda untuk melacak beberapa tugas</li>
                                        <li>Jadikan halaman timer sebagai bookmark di browser Anda untuk akses cepat</li>
                                    </ol>
                                </div>
                                <hr />
                                <div>
                                    <h2 style={{ fontSize: "18px" }}>
                                        <u>Pertanyaan Umum:</u>
                                    </h2>
                                    <p><b>Apakah timer berfungsi di latar belakang?</b></p>
                                    <p>Ya, timer terus berfungsi meskipun Anda berpindah ke tab lain di browser.</p>
                                    <p><b>Apakah saya memerlukan koneksi internet?</b></p>
                                    <p>Anda hanya memerlukan internet untuk memuat halaman pertama kali, setelah itu timer berfungsi tanpa koneksi.</p>
                                    <p><b>Dapatkah saya menggunakan lebih dari satu timer pada saat yang sama?</b></p>
                                    <p>Anda dapat membuka halaman di beberapa tab atau jendela berbeda, masing-masing dengan timer independen.</p>
                                    <p><b>Apa yang terjadi saat timer berakhir?</b></p>
                                    <p>Timer berhenti di angka nol, dan mengeluarkan bunyi peringatan jika diaktifkan, dan warna tampilan berubah menjadi merah.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </div>
    );
};
export default Timer;